/**
 * Fecha calendario en la zona horaria del navegador (no UTC).
 * Evita el desfase típico de `toISOString().slice(0, 10)` al armar tableros / inputs type="date".
 */
export function formatLocalDateYmd(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Suma días a un string YYYY-MM-DD en aritmética de calendario local. */
export function addDaysLocalYmd(ymd, delta) {
  const parts = ymd.split('-').map(Number);
  const d = new Date(parts[0], parts[1] - 1, parts[2]);
  d.setDate(d.getDate() + delta);
  return formatLocalDateYmd(d);
}
